export const rejectObjectUrl = url => {
  window.URL.revokeObjectURL(url);
};

export const openNewTab = url => {
  window.open(url);
};
